import { Select, Table } from "antd";
import { useEffect } from "react";

const API_BASE_URL = "http://192.168.2.2:89/research-api/api/v1";
const USER_NAME = "derivium";
const PASSWORD = "khZjT%67m0z";

const data = [
  {
    key: 1,
    product: "SWAPS",
    // refinitiv: 60,
    // bloomberg: "New York No. 1 Lake Park",
    showSelect: false,
    children: [
      {
        key: 11,
        product: "OIS SWAPS",
        // refinitiv: 60,
        // bloomberg: "New York No. 1 Lake Park",
        showSelect: true
      },
      {
        key: 12,
        product: "POS SWAPS",
        // refinitiv: 60,
        // bloomberg: "New York No. 1 Lake Park",
      },
      {
        key: 13,
        product: "STATE LOAN",
        // refinitiv: 60,
        // bloomberg: "New York No. 1 Lake Park",
        showSelect: true
      }
    ]
  },
  {
    key: 2,
    product: "COMMERCIAL PAPERS",
    refinitiv: 32,
    bloomberg: "Sydney No. 1 Lake Park",
    showSelect: false,
    children: [
      {
        key: 131,
        product: "Jim Green",
        refinitiv: 42,
        address: "London No. 2 Lake Park",
        showSelect: true
      }
    ]
  }
];

const MyTable = () => {
  useEffect(() => {
    (async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/product/mapping`, {
          method: "GET",
          headers: {
            Authorization: "Basic " + btoa(`${USER_NAME}:${PASSWORD}`)
          }
        });
        const responseData = await response.json();
        console.log(responseData);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);
  
  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        // rowSelection={{
        //   ...rowSelection
        // }}
      />
    </>
  );
};
export default MyTable;

const columns = [
  {
    title: "Product",
    dataIndex: "product",
    key: "product"
  },
  {
    title: "Refinitiv",
    dataIndex: "refinitiv",
    key: "refinitiv",
    // width: "12%"
    render: () => <Select placeholder='Frequency' />
  },
  {
    title: "Bloomberg",
    dataIndex: "bloomberg",
    // width: "bloomberg",
    key: "bloomberg",
    render: () => <Select placeholder='Frequency' />
  }
];

// rowSelection objects indicates the need for row selection
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(
      `selectedRowKeys: ${selectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    // console.log(selected, selectedRows, changeRows);
  }
};
